import { render } from "./DevPanel.vue?vue&type=template&id=0a0d85ac&scoped=true&ts=true"
import script from "./DevPanel.vue?vue&type=script&lang=ts"
export * from "./DevPanel.vue?vue&type=script&lang=ts"

import "./DevPanel.vue?vue&type=style&index=0&id=0a0d85ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0d85ac"]])

export default __exports__